import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const labApi = {
  async listRequests(params = {}) {
    const response = await apiClient.get("/lab/requests", { params });
    return { data: unwrapList(response.data), meta: unwrapMeta(response.data) };
  },

  async countRequests(params = {}) {
    const response = await apiClient.get("/lab/requests/count", { params });
    return unwrapEnvelope(response.data, { count: 0 });
  },

  async createRequest(payload) {
    const response = await apiClient.post("/lab/requests", payload);
    return unwrapEnvelope(response.data, null);
  },

  async updateRequestStatus(id, status) {
    const response = await apiClient.patch(`/lab/requests/${id}/status`, { status });
    return unwrapEnvelope(response.data, null);
  },

  async attachResult(id, payload) {
    const response = await apiClient.post(`/lab/requests/${id}/results`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async listResults(params = {}) {
    const response = await apiClient.get("/lab/results", { params });
    return { data: unwrapList(response.data), meta: unwrapMeta(response.data) };
  }
};
